class LocalMessageEndpoint {
    #closeListeners = new Set();
    #messageListeners = new Set();
    #closed = false;
    #peer;
    attachPeer(peer) {
        this.#peer = peer;
    }
    close() {
        if (this.#closed)
            return;
        this.#closed = true;
        for (const listener of [...this.#closeListeners])
            listener();
        this.#peer?.remoteClose();
    }
    postMessage(message) {
        if (this.#closed)
            return;
        this.#peer?.dispatchMessage(message);
    }
    subscribe(listener) {
        this.#messageListeners.add(listener);
        return () => {
            this.#messageListeners.delete(listener);
        };
    }
    subscribeClose(listener) {
        this.#closeListeners.add(listener);
        return () => {
            this.#closeListeners.delete(listener);
        };
    }
    dispatchMessage(message) {
        if (this.#closed)
            return;
        for (const listener of [...this.#messageListeners])
            listener(message);
    }
    remoteClose() {
        if (this.#closed)
            return;
        this.#closed = true;
        for (const listener of [...this.#closeListeners])
            listener();
    }
}
export function createMessageEndpointPair() {
    const left = new LocalMessageEndpoint();
    const right = new LocalMessageEndpoint();
    left.attachPeer(right);
    right.attachPeer(left);
    return [left, right];
}
export function createRpcTransportPair() {
    const [left, right] = createMessageEndpointPair();
    return [createRpcTransport(left), createRpcTransport(right)];
}
export function createRpcTransport(endpoint) {
    return new EndpointRpcTransport(endpoint);
}
class EndpointRpcTransport {
    #closeListeners = new Set();
    #endpoint;
    #messageListeners = new Set();
    #unsubscribeClose;
    #unsubscribeMessage;
    state = "open";
    constructor(endpoint) {
        this.#endpoint = endpoint;
        this.#unsubscribeMessage = endpoint.subscribe((message) => {
            for (const listener of [...this.#messageListeners])
                listener(message);
        });
        this.#unsubscribeClose = endpoint.subscribeClose(() => {
            this.#handleClose();
        });
    }
    close() {
        if (this.state === "closed")
            return;
        this.#endpoint.close();
        this.#handleClose();
    }
    send(message) {
        if (this.state === "closed")
            return;
        this.#endpoint.postMessage(message);
    }
    subscribe(listener) {
        this.#messageListeners.add(listener);
        return () => {
            this.#messageListeners.delete(listener);
        };
    }
    subscribeClose(listener) {
        this.#closeListeners.add(listener);
        return () => {
            this.#closeListeners.delete(listener);
        };
    }
    #handleClose() {
        if (this.state === "closed")
            return;
        this.state = "closed";
        this.#unsubscribeMessage();
        this.#unsubscribeClose();
        for (const listener of [...this.#closeListeners])
            listener();
        this.#closeListeners.clear();
        this.#messageListeners.clear();
    }
}
//# sourceMappingURL=kernel-connector.js.map